import { useCampaignGroupBudgetDistributionEnabled } from '../../../../campaigns-group-form/hooks/useCampaignGroupBudgetDistributionEnabled';
import { isCampaignPartOfFullySharedBudget } from '../../../config/campaignsGroupBudgetDistributionMethod';
import { useCampaignsGroupBudgetDistributionMethod } from './useCampaignsGroupBudgetDistributionMethod';

export const useIsCampaignPartOfFullySharedBudget = () => {
    const isBudgetDistributionEnabled = useCampaignGroupBudgetDistributionEnabled();

    const { campaignsGroupBudgetDistributionMethod } = useCampaignsGroupBudgetDistributionMethod();

    return isBudgetDistributionEnabled && isCampaignPartOfFullySharedBudget(campaignsGroupBudgetDistributionMethod);
};
